<template>
  <DefaultLayout
    :menuIndex="menuIndex"
    openeds="equipment"
  >

    <div
      class="page-header"
      v-if="equId"
    >
      <el-page-header @back="goPath('/equipmentList')">
        <template #content>
          <span class="text-large font-600 mr-3"> 编辑设备 </span>
        </template>
      </el-page-header>
    </div>

    <!-- <div class="equipmentAdd-top-block">
            <p>1.过期时间目前接口还不支持</p>
        </div> -->
    <div style="padding: 20px">
      <div class="form">
        <el-form
          :model="form"
          ref="formRef"
          label-width="120px"
          :rules="rules"
          :inline="false"
          label-position="left"
        >
          <!-- <el-space
            fill
            style="width: 100%; margin-bottom: 10px;"
          >
            <el-alert
              title="装配信息"
              type="info"
              show-icon
              :closable="false"
            >
            </el-alert>
          </el-space> -->

          <el-space
            fill
            style="width: 100%; margin-bottom: 10px;"
          >
            <el-alert
              title="基本信息"
              type="info"
              show-icon
              :closable="false"
            >
            </el-alert>
          </el-space>
          <el-form-item
            label="固定资产编号"
            prop="assetCode"
          >
            <el-input
              v-model="form.assetCode"
              disabled
            />
          </el-form-item>
          <el-form-item
            label="设备名称"
            prop="name"
          >
            <el-radio-group
              class="device-type-radio-group"
              v-model="form.name"
              @change="deviceNameChange"
            >
              <el-radio
                v-for="item in options.deviceName"
                :key="item.id"
                :label="item.id"
                border
                :disabled="equId !== undefined"
              >
                {{ item.name }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="设备描述"
            prop="description"
          >
            <el-input
              v-model="form.description"
              autosize
              type="textarea"
            />
          </el-form-item>
          <el-form-item
            label="工艺类型"
            prop="processType"
          >
            <!-- <el-select v-model="form.processType" placeholder="请选择工艺类型" clearable>
                    <el-option v-for="item in options.processType" :key="item.id" :label="item.name" :value="item.id" />
                </el-select> -->
            <el-radio-group v-model="form.processType">
              <el-radio
                v-for="item in options.processType"
                :key="item.id"
                :label="item.id"
                border
                :disabled="equId !== undefined"
              >
                {{ item.name }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="机械类型"
            prop="mechanicalType"
          >
            <!-- <el-select v-model="form.mechanicalType" placeholder="请选择机械类型" clearable>
                    <el-option v-for="item in options.mechanicalType" :key="item.id" :label="item.name"
                        :value="item.id" />
                </el-select> -->
            <el-radio-group v-model="form.mechanicalType">
              <el-radio
                v-for="item in options.mechanicalType"
                :key="item.id"
                :label="item.id"
                border
                :disabled="equId !== undefined"
              >
                {{ item.name }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="电子说明书"
            prop="qrCode"
          >
            <el-select
              v-model="form.qrCode"
              placeholder="请选择电子说明书"
              clearable
            >
              <el-option
                v-for="item in options.qrCode"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="绑定二维码ID"
            prop="qrCodeUrlId"
          >
            <el-input
              v-model="form.qrCodeUrlId"
              clearable
              placeholder="请输入绑定二维码ID"
            />
          </el-form-item>
          <el-form-item
            label="备注"
            prop="remark"
          >
            <el-input
              v-model="form.remark"
              autosize
              type="textarea"
            />
          </el-form-item>


          <el-form-item
            label="设备照片"
            prop="picList"
          >
            <el-upload
              class="upload-demo"
              action
              :http-request="(file) => uploadFile(file, 'doc')"
              ref="upload"
              :limit="fileLimit"
              :on-remove="handleRemovePic"
              :file-list="form.picList"
              :on-exceed="handleExceed"
              :before-upload="(file) => beforeUpload(file, filePicType, filePicSize)"
              :show-file-list="true"
              :headers="headers"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
            >
              <!-- action="/api/file/fileUpload" -->
              <el-button
                class="btn"
                type="primary"
              ><i class="el-icon-paperclip"></i>上传图片</el-button>
              <template #tip>
                <div class="el-upload__tip">
                  只能上传jpeg / jpg / tiff / png / psd / raw / eps / svg文件，且不超过10MB
                </div>
              </template>
            </el-upload>
            <el-dialog v-model="dialogVisible">
              <img
                w-full
                :src="dialogImageUrl"
                alt="Preview Image"
              />
            </el-dialog>
          </el-form-item>

          <el-space
            fill
            style="width: 100%; margin-bottom: 10px;"
          >
            <el-alert
              title="版本信息"
              type="info"
              show-icon
              :closable="false"
            >
            </el-alert>
          </el-space>
          <el-form-item
            label="版本号"
            prop="versionId"
          >
            <el-select
              v-model="form.versionId"
              placeholder="请选择版本号"
              clearable
            >
              <el-option
                v-for="item in options.equipmentVersionFilter"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="工艺工装版本"
            prop="processToolingId"
          >
            <el-select
              v-model="form.processToolingId"
              placeholder="请选择工艺工装版本"
              clearable
            >
              <el-option
                v-for="item in options.processTooling"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="夹持工装版本"
            prop="clampToolingId"
          >
            <el-select
              v-model="form.clampToolingId"
              placeholder="请选择夹持工装版本"
              clearable
            >
              <el-option
                v-for="item in options.clampTooling"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="供胶系统版本"
            prop="glueSupplySystemId"
          >
            <el-select
              v-model="form.glueSupplySystemId"
              placeholder="请选择供胶系统版本"
              clearable
            >
              <el-option
                v-for="item in options.glueSupplySystem"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="清洗机构版本"
            prop="cleaningMechanismId"
          >
            <el-select
              v-model="form.cleaningMechanismId"
              placeholder="请选择清洗机构版本"
              clearable
            >
              <el-option
                v-for="item in options.cleaningMechanism"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="机身版本"
            prop="machineBodyId"
          >
            <el-select
              v-model="form.machineBodyId"
              placeholder="请选择机身版本"
              clearable
            >
              <el-option
                v-for="item in options.machineBody"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="运动机构版本"
            prop="motionMechanismId"
          >
            <el-select
              v-model="form.motionMechanismId"
              placeholder="请选择运动机构版本"
              clearable
            >
              <el-option
                v-for="item in options.motionMechanism"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-space
            fill
            style="width: 100%; margin-bottom: 10px;"
          >
            <el-alert
              title="人员信息"
              type="info"
              show-icon
              :closable="false"
            >
            </el-alert>
          </el-space>
          <el-form-item
            label="机构装配人员"
            prop="mechanismAssembleUser"
          >
            <el-input
              v-model="form.mechanismAssembleUser"
              clearable
            />
          </el-form-item>
          <el-form-item
            label="电气接线人员"
            prop="electricWireUser"
          >
            <el-input
              v-model="form.electricWireUser"
              clearable
            />
          </el-form-item>
          <el-form-item
            label="调试人员"
            prop="debugUser"
          >
            <el-input
              v-model="form.debugUser"
              clearable
            />
          </el-form-item>
          <el-form-item
            label="检验人员"
            prop="checkUser"
          >
            <el-input
              v-model="form.checkUser"
              clearable
            />
          </el-form-item>
          <el-form-item
            label="设备出厂检验项目"
            prop="factoryInspectionRecords"
          >
            <div class="factory-inspection-panel">
              <el-table
                :data="form.factoryInspectionRecords"
                border
                empty-text="当前设备暂无出厂检验项目"
              >
                <el-table-column
                  type="index"
                  label="#"
                  width="55"
                  :resizable="false"
                />
                <el-table-column
                  prop="name"
                  label="检查项"
                  min-width="260"
                  :resizable="false"
                />
                <el-table-column
                  label="负责人"
                  width="140"
                  :resizable="false"
                >
                  <template #default="scope">
                    <el-tag
                      class="inspection-owner-tag"
                      type="info"
                      effect="plain"
                    >
                      {{ scope.row.ownerName || '' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  label="检查人"
                  width="220"
                  :resizable="false"
                >
                  <template #default="scope">
                    <el-input
                      v-model="scope.row.inspectorName"
                      clearable
                      placeholder="请输入检查人"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="equId !== undefined"
                  label="状态"
                  width="100"
                  :resizable="false"
                >
                  <template #default="scope">
                    <el-tag :type="scope.row.isFinished ? 'success' : 'info'">
                      {{ scope.row.isFinished ? '已完成' : '未完成' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="equId !== undefined"
                  label="完成时间"
                  width="160"
                  :resizable="false"
                >
                  <template #default="scope">
                    {{ scope.row.finishTime ? moment(scope.row.finishTime).format('YYYY-MM-DD HH:mm') : '-' }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>

          <el-space
            fill
            style="width: 100%; margin-bottom: 10px;"
          >
            <el-alert
              title="物理信息"
              type="info"
              show-icon
              :closable="false"
            >
            </el-alert>
          </el-space>
          <el-form-item
            label="规格型号"
            prop="specificationModelId"
          >
            <el-select
              v-model="form.specificationModelId"
              placeholder="请选择规格型号"
              clearable
            >
              <el-option
                v-for="item in options.specification"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="尺寸(mm)"
            prop="shapeSize"
          >
            <el-input
              v-model="form.shapeSize"
              clearable
            />
          </el-form-item>
          <el-form-item
            label="额定电压(V)"
            prop="ratedVoltage"
          >
            <el-input
              v-model="form.ratedVoltage"
              clearable
            />
          </el-form-item>
          <el-form-item
            label="额定功率(W)"
            prop="ratedPower"
          >
            <el-input
              v-model="form.ratedPower"
              clearable
            />
          </el-form-item>
          <el-form-item
            label="额定气压(MPa)"
            prop="ratedAirPressure"
          >
            <el-input
              v-model="form.ratedAirPressure"
              clearable
            />
          </el-form-item>
          <el-form-item
            label="重量(Kg)"
            prop="weight"
          >
            <el-input
              v-model="form.weight"
              clearable
            />
          </el-form-item>

          <el-space
            fill
            style="width: 100%; margin-bottom: 10px;"
          >
            <el-alert
              title="网络信息"
              type="info"
              show-icon
              :closable="false"
            >
            </el-alert>
          </el-space>
          <el-form-item
            label="设备MAC"
            prop="mac"
          >
            <el-input
              v-model="form.mac"
              clearable
            />
          </el-form-item>
          <!-- <el-form-item
          label="设备IP"
          prop="ip"
        >
          <el-input
            v-model="form.ip"
            clearable
          />
        </el-form-item> -->

          <el-form-item
            label="设备IP"
            prop="ipList"
          >
            <el-card
              class="box-card"
              shadow="never"
            >
              <div
                v-for="item in form.ipList"
                :key="item"
                class="text item"
              >
                <el-input
                  v-model="item.ip"
                  clearable
                  :disabled="item.disabled"
                >
                  <template #suffix>
                    {{ item.name }}
                  </template>
                </el-input>
              </div>
            </el-card>
          </el-form-item>
          <el-space
            fill
            style="width: 100%; margin-bottom: 10px;"
          >
            <el-alert
              title="商业信息"
              type="info"
              show-icon
              :closable="false"
            >
            </el-alert>
          </el-space>
          <el-form-item
            label="项目模块"
            prop="project"
          >
            <el-select
              v-model="form.project"
              placeholder="请选择项目模块"
              clearable
            >
              <el-option
                v-for="item in options.project"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="是否为产线"
            prop="isProductionLine"
          >
            <div class="isProductionLine-switch">
              <el-switch
                v-model="form.isProductionLine"
                inline-prompt
                active-text="是"
                inactive-text="否"
                size="large"
                @change="changeIsProductionLine"
              />
            </div>
          </el-form-item>
          <el-form-item
            label="所属产线"
            prop="productionLine"
          >
            <el-select
              v-model="form.productionLine"
              placeholder="请选择所属产线"
              clearable
              :disabled="!form.isProductionLine"
              @visible-change="chooseToProductionLine"
            >
              <el-option
                v-for="item in options.productionLines"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="商业类型"
            prop="nature"
          >
            <!-- <el-select v-model="form.nature" placeholder="请选择商业类型" clearable @change="HandleChangeNature">
                    <el-option label="买断" value="买断" />
                    <el-option label="租赁" value="租赁" />
                </el-select> -->
            <el-radio-group
              v-model="form.nature"
              @change="HandleChangeNature"
            >
              <el-radio
                label="买断"
                border
              >买断</el-radio>
              <el-radio
                label="租赁"
                border
              >租赁</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="出厂日期"
            prop="factoryDate"
          >
            <el-date-picker
              v-model="form.factoryDate"
              type="date"
              placeholder="请选择日期"
            />
          </el-form-item>
          <el-form-item
            label="上线时间"
            prop="creationTime"
          >
            <el-date-picker
              v-model="form.creationTime"
              type="date"
              placeholder="请选择日期"
            />
          </el-form-item>
          <el-form-item
            label="过期时间"
            prop="offlineTime"
            :rules="!offlineTimeDisabled ? [{ required: true, message: '请填写过期时间', trigger: 'blur' }] : [{ required: false }]"
          >
            <el-date-picker
              v-model="form.offlineTime"
              type="date"
              placeholder="请选择日期"
              :disabled="offlineTimeDisabled"
            />
          </el-form-item>
          <el-form-item
            label="上一次保养日期"
            prop="lastMaintenanceDate"
          >
            <el-date-picker
              v-model="form.lastMaintenanceDate"
              type="date"
              placeholder="请选择日期"
            />
          </el-form-item>
          <el-form-item
            label="启用状态"
            prop="isEnable"
          >
            <div class="isProductionLine-switch">
              <el-switch
                v-model="form.isEnable"
                inline-prompt
                active-text="开"
                inactive-text="关"
                size="large"
              />
            </div>
          </el-form-item>
          <el-form-item
            label="所属公司"
            prop="company"
          >
            <el-select
              v-model="form.company"
              placeholder="请选择所属公司"
              clearable
              @visible-change="chooseToCompany"
              @change="form.factory = ''; form.workshop = '';"
            >
              <el-option
                v-for="item in options.company"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="所属工厂"
            prop="factory"
          >
            <el-select
              v-model="form.factory"
              placeholder="请选择所属工厂"
              clearable
              @visible-change="chooseCompanyToFactories"
              @change="form.workshop = '';"
            >
              <el-option
                v-for="item in options.factory"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="所属车间"
            prop="workshop"
          >
            <el-select
              v-model="form.workshop"
              placeholder="请选择所属车间"
              clearable
              @visible-change="chooseFactoryToWorkshops"
            >
              <el-option
                v-for="item in options.workshop"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-divider />
          <el-form-item>
            <el-button
              size="large"
              @click="formCancel(formRef)"
              style="margin-right: 80px;width: 100px;"
              v-if="equId === undefined"
            >重置</el-button>
            <el-button
              size="large"
              type="primary"
              @click="submitForm(formRef)"
              style="width: 100px;"
            >{{ equId === undefined
              ? '添加' : '修改' }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </DefaultLayout>
</template>

<script>
export default {
  name: 'EquipmentAdd'
}
</script>

<script setup>
import DefaultLayout from '../components/layout/DefaultLayout.vue'
import router from '../router'
import { EquipmentInfo, Companies, Factories, Workshops, ProductionLines, EquipmentSort, ProjectRecord, QrCode, EquipmentVersion, CommonProperty } from '../api/request.js'
import moment from 'moment'
import { reactive, onMounted, ref, onActivated, onDeactivated, onBeforeMount } from "vue"// 引入ref （reactive用来引入对象或数组）
import { ElMessage, ElMessageBox } from 'element-plus'
import axios from 'axios'
import { useRoute } from 'vue-router'

//上传后的文件列表
// const filePicList = ref([])
const filePicType = ["jpeg", "jpg", "tiff", "png", "psd", "raw", "eps", "svg"]
// 运行上传文件大小，单位 M
const filePicSize = 10
// 附件数量限制
const fileLimit = 99
//请求头
const headers = { "Content-Type": "multipart/form-data" }
const beforeUpload = (file, verify, fileSize) => {
  if (file.type != "" || file.type != null || file.type != undefined) {
    //截取文件的后缀，判断文件类型
    const FileExt = file.name.replace(/.+\./, "").toLowerCase();
    //计算文件的大小
    const isLt5M = file.size / 1024 / 1024 < fileSize; //这里做文件大小限制
    //如果大于50M
    if (!isLt5M) {
      ElMessage({
        message: `上传文件大小不能超过 ${fileSize}MB！`,
        type: 'warning',
      })
      return false;
    }
    //如果文件类型不在允许上传的范围内
    if (verify.includes(FileExt)) {
      return true;
    }
    else {
      ElMessage({
        message: '上传文件格式不正确！',
        type: 'warning',
      })
      return false;
    }
  }
}
//上传了的文件给移除的事件，由于我没有用到默认的展示，所以没有用到
const handleRemovePic = (i, arr) => {
  form.picList = arr
}
//这是我自定义的移除事件
// const handleClose = (i) => {
//   this.fileList.splice(i, 1);//删除上传的文件
//   if (this.fileList.length == 0) {//如果删完了
//     this.fileflag = true;//显示url必填的标识
//     this.$set(this.rules.url, 0, { required: true, validator: this.validatorUrl, trigger: 'blur' })//然后动态的添加本地方法的校验规则
//   }
// }
//超出文件个数的回调
const handleExceed = () => {
  ElMessage({
    message: '超出最大上传文件数量的限制！',
    type: 'warning',
  })
  return
}
//上传文件的事件
const uploadFile = (item, type) => {
  ElMessage('文件上传中........')
  //上传文件的需要formdata类型;所以要转
  let FormDatas = new FormData()
  FormDatas.append('files', item.file);
  // console.log(item.file, FormDatas.get('files'))
  axios({
    method: "post",
    url: `https://api.iot.zs-tek.com/File/Upload`,
    data: FormDatas,
    headers: { "Content-Type": "multipart/form-data" }
  }).then((res) => {
    // console.log(res.data)
    form.picList.push(item.file)
    let i = form.picList.indexOf(item.file)
    form.picList[i].url = 'https://api.iot.zs-tek.com' + res.data.content;
    // form.picList = filePicList.value.map(item => { return item.url })
    // console.log(form.picList)
    handleSuccess()
  })

  // this.$axios({
  //   method: 'post',
  //   url: '/file/fileUpload',
  //   headers: this.headers,
  //   timeout: 30000,
  //   data: FormDatas
  // }).then(res => {
  //   if (res.data.id != '' || res.data.id != null) {
  //     this.fileList.push(item.file);//成功过后手动将文件添加到展示列表里
  //     let i = this.fileList.indexOf(item.file)
  //     this.fileList[i].id = res.data.id;//id也添加进去，最后整个大表单提交的时候需要的
  //     if (this.fileList.length > 0) {//如果上传了附件就把校验规则给干掉
  //       this.fileflag = false;
  //       this.$set(this.rules.url, 0, '')
  //     }
  //     //this.handleSuccess();
  //   }
  // })
}
//上传成功后的回调
const handleSuccess = () => {
  ElMessage({
    message: '上传成功！',
    type: 'success',
  })
}

const dialogImageUrl = ref('')
const dialogVisible = ref(false)

const handlePictureCardPreview = (uploadFile) => {
  dialogImageUrl.value = uploadFile.url
  dialogVisible.value = true
}

// const inputValue = ref("我是响应的值"); // 初始值，空值设置：ref('')
const formRef = ref()

const offlineTimeDisabled = ref(true)

const menuIndex = ref('/equipmentAdd');

// 以下为常见的响应数据示例（对象、数组、基本类型）
// const user = reactive({
//     name: "",
//     address: "",
// })

const equId = ref(undefined)

const form = reactive({
  mechanismAssembleUser: '',
  electricWireUser: '',
  debugUser: '',
  checkUser: '',

  name: 1,
  description: '',
  mac: '',
  processType: '',
  mechanicalType: '',
  company: '',
  factory: '',
  workshop: '',
  productionLine: '',
  ip: '',
  creationTime: new Date(),
  offlineTime: '',
  nature: '',
  isProductionLine: false,
  isEnable: true,
  remark: '',
  project: '',
  ipList: [
    { ip: '', name: '内网IP', disabled: true },
    { ip: '', name: '外网IP', disabled: true },
    { ip: '', name: '控制器IP', disabled: true },
    { ip: '', name: 'PlcIP', disabled: true },
    { ip: '', name: '机器人IP', disabled: true },
    { ip: '', name: '3D机器视觉IP', disabled: true },
    { ip: '', name: '2D机器视觉IP', disabled: true },
    { ip: '', name: '皮带伺服电机IP', disabled: true }
  ],
  qrCode: '',
  qrCodeUrlId: '',
  picList: [],
  assetCode: undefined,
  specificationModelId: undefined, //规格型号
  versionId: undefined, //版本号
  shapeSize: undefined, //外形尺寸
  ratedVoltage: undefined, //额定电压
  ratedPower: undefined, //额定功率
  ratedAirPressure: undefined, //额定气压
  weight: undefined, //设备重量
  factoryDate: new Date(), //出厂日期
  lastMaintenanceDate: '', //上一次保养日期
  processToolingId: undefined, //工艺工装版本
  clampToolingId: undefined, //夹持工装版本
  glueSupplySystemId: undefined, //供胶系统版本
  cleaningMechanismId: undefined, //清洗工装版本
  machineBodyId: undefined, //机身版本
  motionMechanismId: undefined, //运动机构版本
  factoryInspectionRecords: []
})

const options = reactive({
  deviceName: [
    // {
    //   id: '1',
    //   name: '智能涂胶专机'
    // },
    // {
    //   id: '2',
    //   name: '智能喷胶专机'
    // },
    // {
    //   id: '3',
    //   name: '智能打磨专机'
    // }
  ],
  qrCode: [
    // {
    //   id: '1',
    //   title: '说明书1'
    // },
    // {
    //   id: '2',
    //   title: '说明书2'
    // }
  ],
  project: [
    // {
    //   id: '1',
    //   name: '项目1'
    // },
    // {
    //   id: '2',
    //   name: '项目2'
    // }
  ],
  processType: [
    // {
    //     id: '1',
    //     code: 'PJ',
    //     name: '喷胶'
    // }
  ],
  mechanicalType: [],
  company: [
    // {
    //     id: '1',
    //     name: '浙江大东鞋业'
    // }
  ],
  factory: [],
  workshop: [],
  productionLines: [
    // {
    //     code: 'p1',
    //     id: '1',
    //     name: '1号线'
    // }
  ],
  equipmentVersion: [
    // {
    //   equipmentSortId: 1,
    //   id: 1,
    //   name: "MH5.0"
    // }
  ],
  equipmentVersionFilter: [

  ],
  specification: [
    // {
    //   group: '',
    //   id: 1,
    //   index: null,
    //   name: '',
    //   remark: '',
    //   state: 1
    // }
  ],
  processTooling: [],
  clampTooling: [],
  glueSupplySystem: [],
  cleaningMechanism: [],
  machineBody: [],
  motionMechanism: []
})

const rules = reactive({
  lastMaintenanceDate: [
    { required: true, message: '请选择上一次保养日期', trigger: 'blur' },
  ],
  name: [
    { required: true, message: '请输入设备名称', trigger: 'blur' },
  ],
  mac: [
    { required: true, message: '请输入设备MAC', trigger: 'blur' },
  ],
  ip: [
    { required: true, message: '请输入设备IP', trigger: 'blur' },
  ],
  project: [
    { required: true, message: '请选择项目模块', trigger: 'blur' },
  ],
  nature: [
    { required: true, message: '请输入商业模式', trigger: 'blur' },
  ],
  processType: [
    { required: true, message: '请选择工艺类型', trigger: 'blur' },
  ],
  mechanicalType: [
    { required: true, message: '请选择机械类型', trigger: 'blur' },
  ],
  company: [
    { required: true, message: '请选择所属公司', trigger: 'blur' },
  ],
  factory: [
    { required: true, message: '请选择所属工厂', trigger: 'blur' },
  ],
  workshop: [
    { required: true, message: '请选择所属车间', trigger: 'blur' },
  ],
  productionLine: [
    { required: false, message: '请选择产线', trigger: 'blur' },
  ],
})

const validateFactoryInspectionRecords = () => {
  for (const item of form.factoryInspectionRecords) {
    if (!item.inspectorName || item.inspectorName.trim() === '') {
      ElMessage({
        message: `请填写【${item.name}】的检查人`,
        type: 'warning',
      })
      return false
    }
  }
  return true
}

const nullableNumber = (value) => {
  return value === '' || value === undefined ? null : Number(value)
}

const loadFactoryInspectionItemTemplates = (sortId) => {
  if (!sortId) {
    form.factoryInspectionRecords = []
    return
  }

  EquipmentInfo.GetFactoryInspectionItemTemplates(sortId).then((res) => {
    form.factoryInspectionRecords = res.map((item) => {
      return {
        templateItemId: item.templateItemId,
        name: item.name,
        ownerName: item.defaultOwnerName || '',
        inspectorName: item.defaultInspectorName || '',
        orderIndex: item.orderIndex
      }
    })
  })
}

const loadFactoryInspectionRecords = (equipmentId) => {
  EquipmentInfo.GetFactoryInspectionRecords(equipmentId).then((res) => {
    form.factoryInspectionRecords = res.map((item) => {
      return {
        id: item.id,
        templateItemId: item.templateItemId,
        name: item.name,
        ownerName: item.ownerName || item.defaultOwnerName || '',
        inspectorName: item.inspectorName || '',
        isFinished: item.isFinished,
        finishTime: item.finishTime,
        orderIndex: item.orderIndex
      }
    })
  })
}

const updateFactoryInspectionRecordInspectors = async () => {
  for (const item of form.factoryInspectionRecords) {
    const res = await EquipmentInfo.UpdateFactoryInspectionRecordInspector({
      id: item.id,
      inspectorName: item.inspectorName
    })
    if (res.code === 0) {
      throw new Error(res.message)
    }
  }
}

onBeforeMount(() => {
  equId.value = useRoute().query.id
  // console.log(equId.value)
})

onMounted(async () => {
  //请求工艺类型
  await EquipmentInfo.GetEquipmentProcessTypes().then((res) => {
    // console.log(res);
    let optionsTem = [];
    for (let i = 0, len = res.length; i < len; i++) {
      optionsTem.push({
        id: res[i].id,
        code: res[i].code,
        name: res[i].name
      });
    }
    options.processType = optionsTem;
  })
  //请求机械类型
  await EquipmentInfo.GetEquipmentMechanicalTypes().then((res) => {
    // console.log(res);
    let optionsTem = [];
    for (let i = 0, len = res.length; i < len; i++) {
      optionsTem.push({
        id: res[i].id,
        code: res[i].code,
        name: res[i].name
      });
    }
    options.mechanicalType = optionsTem;
  })
  //请求设备类别
  await EquipmentSort.List().then((res) => {
    // console.log(res);
    options.deviceName = res;
  })
  //请求项目模块
  await ProjectRecord.List().then((res) => {
    // console.log(res);
    options.project = res;
  })
  //请求电子说明书列表
  await QrCode.GetDropDownList().then((res) => {
    // console.log(res);
    options.qrCode = res?.content;
  })
  //请求设备版本
  await EquipmentVersion.GetEquipmentVersionList().then((res) => {
    // console.log(res);
    options.equipmentVersion = res;
    options.equipmentVersionFilter = options.equipmentVersion.filter((item) => { return item.equipmentSortId === form.name })
  })
  if (equId.value === undefined) {
    loadFactoryInspectionItemTemplates(form.name)
  }
  //请求规格型号
  await CommonProperty.GetListByGroup('specification').then((res) => {
    // console.log(res);
    options.specification = res
  })
  //请求工艺工装版本
  await CommonProperty.GetListByGroup('processTooling').then((res) => {
    // console.log(res);
    options.processTooling = res
  })
  //请求夹持工装版本
  await CommonProperty.GetListByGroup('clampTooling').then((res) => {
    // console.log(res);
    options.clampTooling = res
  })
  //请求供胶系统版本
  await CommonProperty.GetListByGroup('glueSupplySystem').then((res) => {
    // console.log(res);
    options.glueSupplySystem = res
  })
  //请求清洗工装版本
  await CommonProperty.GetListByGroup('cleaningMechanism').then((res) => {
    // console.log(res);
    options.cleaningMechanism = res
  })
  //请求机身版本
  await CommonProperty.GetListByGroup('machineBody').then((res) => {
    // console.log(res);
    options.machineBody = res
  })
  //请求运动机构版本
  await CommonProperty.GetListByGroup('motionMechanism').then((res) => {
    // console.log(res);
    options.motionMechanism = res
  })

  if (equId.value !== undefined) {
    //请求设备初始化
    EquipmentInfo.GetEquipments(null, equId.value, null, null, null).then((res) => {
      form.mechanismAssembleUser = res[0].mechanismAssembleUser
      form.electricWireUser = res[0].electricWireUser
      form.debugUser = res[0].debugUser
      form.checkUser = res[0].checkUser

      // console.log(res);
      form.assetCode = res[0].assetCode
      form.name = res[0].sortId
      deviceNameChange(form.name)
      loadFactoryInspectionRecords(equId.value)
      form.description = res[0].description
      form.processType = res[0].processTypeId
      form.mechanicalType = res[0].mechanicalTypeId
      form.qrCode = res[0].qrCodeId === 0 ? '' : res[0].qrCodeId
      form.qrCodeUrlId = res[0].qrCodeUrlId || ''
      form.remark = res[0].remark
      if (res[0].imgs.length > 0) {
        for (const ele of res[0].imgs) {
          form.picList.push({
            url: ele.url,
            name: ele.name,
            file: new File([], ele.name, {})
          })
        }
      }
      form.mac = res[0].mac
      form.ipList[0].ip = res[0].internalIP
      form.ipList[1].ip = res[0].externalIP
      form.ipList[2].ip = res[0].controllerIP
      form.ipList[3].ip = res[0].plcIP
      form.ipList[4].ip = res[0].robotIP
      form.ipList[5].ip = res[0].camera3DIP
      form.ipList[6].ip = res[0].camera2DIP
      form.ipList[7].ip = res[0].motorIP
      form.project = res[0].projectRecordId
      form.isProductionLine = res[0].isProductionLine
      form.productionLine = res[0].productionLineId
      form.nature = res[0].nature
      form.creationTime = res[0].creationTime
      form.expireDate = res[0].expireDate
      form.isEnable = res[0].isEnable
      chooseToCompany(res[0].companyId)
      form.company = res[0].companyId
      chooseCompanyToFactories(res[0].factoryId)
      form.factory = res[0].factoryId
      chooseFactoryToWorkshops(res[0].workshopId)
      form.workshop = res[0].workshopId

      form.specificationModelId = res[0].specificationModelId === 0 ? '' : res[0].specificationModelId
      form.versionId = res[0].versionId === 0 ? '' : res[0].versionId
      form.shapeSize = res[0].shapeSize
      form.ratedVoltage = res[0].ratedVoltage
      form.ratedPower = res[0].ratedPower
      form.ratedAirPressure = res[0].ratedAirPressure
      form.weight = res[0].weight
      form.factoryDate = res[0].factoryDate
      form.lastMaintenanceDate = res[0].lastMaintenanceDate

      form.processToolingId = res[0].processToolingVersionId === 0 ? '' : res[0].processToolingVersionId
      form.clampToolingId = res[0].clampToolingVersionId === 0 ? '' : res[0].clampToolingVersionId
      form.glueSupplySystemId = res[0].glueSupplySystemVersionId === 0 ? '' : res[0].glueSupplySystemVersionId
      form.cleaningMechanismId = res[0].cleaningMechanismVersionId === 0 ? '' : res[0].cleaningMechanismVersionId
      form.machineBodyId = res[0].machineBodyVersionId === 0 ? '' : res[0].machineBodyVersionId
      form.motionMechanismId = res[0].motionMechanismVersionId === 0 ? '' : res[0].motionMechanismVersionId
    })
  }
})

const deviceNameChange = (value) => {
  options.equipmentVersionFilter = options.equipmentVersion.filter((item) => { return item.equipmentSortId === value })
  form.versionId = undefined
  if (equId.value === undefined) {
    loadFactoryInspectionItemTemplates(value)
  }
  switch (value) {
    // 涂胶
    case 1:
      form.ipList = [
        { ip: '', name: '内网IP', disabled: false },
        { ip: '', name: '外网IP', disabled: false },
        { ip: '', name: '控制器IP', disabled: false },
        { ip: '', name: 'PlcIP', disabled: true },
        { ip: '', name: '机器人IP', disabled: true },
        { ip: '', name: '3D机器视觉IP', disabled: true },
        { ip: '', name: '2D机器视觉IP', disabled: true },
        { ip: '', name: '皮带伺服电机IP', disabled: true }
      ]
      break;
    // 喷胶
    case 2:
      form.ipList = [
        { ip: '', name: '内网IP', disabled: false },
        { ip: '', name: '外网IP', disabled: false },
        { ip: '', name: '控制器IP', disabled: true },
        { ip: '', name: 'PlcIP', disabled: false },
        { ip: '', name: '机器人IP', disabled: false },
        { ip: '', name: '3D机器视觉IP', disabled: false },
        { ip: '', name: '2D机器视觉IP', disabled: false },
        { ip: '', name: '皮带伺服电机IP', disabled: false }
      ]
      break;
    // 打磨
    case 3:
      form.ipList = [
        { ip: '', name: '内网IP', disabled: false },
        { ip: '', name: '外网IP', disabled: false },
        { ip: '', name: '控制器IP', disabled: false },
        { ip: '', name: 'PlcIP', disabled: false },
        { ip: '', name: '机器人IP', disabled: false },
        { ip: '', name: '3D机器视觉IP', disabled: false },
        { ip: '', name: '2D机器视觉IP', disabled: false },
        { ip: '', name: '皮带伺服电机IP', disabled: false }
      ]
      break;
  }
}

const chooseToCompany = (val) => {
  if (val) {
    Companies.GetCompanyAccountInformation().then((res) => {
      // console.log(res);
      let optionsTem = [];
      for (let i = 0, len = res.length; i < len; i++) {
        optionsTem.push({
          id: res[i].id,
          name: res[i].name
        });
      }
      options.company = optionsTem;
    })
  }
}

const chooseCompanyToFactories = (val) => {
  if (val) {
    // form.factory = '';
    options.factory = [];
    // form.workshop = '';
    options.workshop = [];

    if (form.company !== '') {
      Factories.GetFactories(form.company).then((res) => {
        // console.log(res);
        let optionsTem = [];
        for (let i = 0, len = res.length; i < len; i++) {
          optionsTem.push({
            id: res[i].id,
            name: res[i].name
          });
        }
        options.factory = optionsTem;
      })
    }
  }
}

const chooseFactoryToWorkshops = (val) => {
  if (val) {
    // form.workshop = '';
    options.workshop = [];

    if (form.factory !== '') {
      Workshops.GetWorkshops(form.factory).then((res) => {
        // console.log(res);
        let optionsTem = [];
        for (let i = 0, len = res.length; i < len; i++) {
          optionsTem.push({
            id: res[i].id,
            name: res[i].name
          });
        }
        options.workshop = optionsTem;
      })
    }
  }
}

const changeIsProductionLine = (val) => {
  if (!val) {
    form.productionLine = '';
  }
}

const chooseToProductionLine = () => {
  ProductionLines.Get().then((res) => {
    // console.log(res);
    let optionsTem = [];
    for (let i = 0, len = res.length; i < len; i++) {
      optionsTem.push({
        id: res[i].id,
        name: res[i].name,
        code: res[i].code
      });
    }
    options.productionLines = optionsTem;
  })
}

const submitForm = (formEl) => {
  if (!formEl) return
  // console.log(form);
  formEl.validate((valid) => {
    if (valid) {
      if (!validateFactoryInspectionRecords()) {
        return false
      }
      // console.log(form);
      if (equId.value === undefined) {
        ElMessageBox.confirm(
          '是否确定添加该设备?',
          '添加',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        ).then(() => {
          // console.log(form)
          EquipmentInfo.AddEquipment({
            mechanismAssembleUser: form.mechanismAssembleUser,
            electricWireUser: form.electricWireUser,
            debugUser: form.debugUser,
            checkUser: form.checkUser,

            companyId: form.company,
            factoryId: form.factory,
            workshopId: form.workshop,
            productionLineId: form.productionLine === '' ? null : form.productionLine,
            name: form.name,
            mac: form.mac,
            mechanicalTypeId: form.mechanicalType,
            processTypeId: form.processType,
            creationTime: form.creationTime === '' ? null : moment(form.creationTime).format('YYYY-MM-DD'),
            expireDate: form.offlineTime === '' ? null : moment(form.offlineTime).format('YYYY-MM-DD'),
            nature: form.nature,
            isProductionLine: form.isProductionLine,
            isEnable: form.isEnable,
            remark: form.remark,
            sortId: form.name,
            description: form.description,
            internalIP: form.ipList[0].ip,
            externalIP: form.ipList[1].ip,
            controllerIP: form.ipList[2].ip,
            plcIP: form.ipList[3].ip,
            robotIP: form.ipList[4].ip,
            camera3DIP: form.ipList[5].ip,
            camera2DIP: form.ipList[6].ip,
            motorIP: form.ipList[7].ip,
            projectRecordId: form.project,
            qrCodeId: nullableNumber(form.qrCode),
            qrCodeUrlId: form.qrCodeUrlId,
            imgs: form.picList.map((item) => item.url),
            specificationModelId: form.specificationModelId, //规格型号
            versionId: form.versionId, //版本号
            shapeSize: form.shapeSize, //外形尺寸
            ratedVoltage: Number(form.ratedVoltage), //额定电压
            ratedPower: Number(form.ratedPower), //额定功率
            ratedAirPressure: Number(form.ratedAirPressure), //额定气压
            weight: Number(form.weight), //设备重量
            factoryDate: form.factoryDate === '' ? null : moment(form.factoryDate).format('YYYY-MM-DD'), //出厂日期
            lastMaintenanceDate: form.lastMaintenanceDate === '' ? null : moment(form.lastMaintenanceDate).format('YYYY-MM-DD'),  //上一次保养日期
            processToolingVersionId: nullableNumber(form.processToolingId),
            clampToolingVersionId: nullableNumber(form.clampToolingId),
            glueSupplySystemVersionId: nullableNumber(form.glueSupplySystemId),
            cleaningMechanismVersionId: nullableNumber(form.cleaningMechanismId),
            machineBodyVersionId: nullableNumber(form.machineBodyId),
            motionMechanismVersionId: nullableNumber(form.motionMechanismId),
            factoryInspectionRecords: form.factoryInspectionRecords.map((item) => {
              return {
                templateItemId: item.templateItemId,
                inspectorName: item.inspectorName
              }
            })
          }).then((res) => {
            if (res.code === 0) {
              ElMessage({
                showClose: true,
                message: res.message,
                type: 'warning',
              })
              return
            }
            // ElMessage({
            //   showClose: true,
            //   message: '添加成功',
            //   type: 'success',
            // });
            ElMessageBox.alert(
              `${res.message}`,
              '添加成功',
              {
                confirmButtonText: '好的',
                type: 'success',
                showClose: false
              }
            )
              .then(() => {
                formEl.resetFields();
              })
          })
        })
          .catch(() => {
            ElMessage({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        {
          ElMessageBox.confirm(
            '是否确定修改该设备?',
            '修改',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }
          ).then(() => {
            // console.log(form)
            EquipmentInfo.EditEquipment({
              mechanismAssembleUser: form.mechanismAssembleUser,
              electricWireUser: form.electricWireUser,
              debugUser: form.debugUser,
              checkUser: form.checkUser,

              id: Number(equId.value),
              companyId: form.company,
              factoryId: form.factory,
              workshopId: form.workshop,
              productionLineId: form.productionLine === '' ? null : form.productionLine,
              name: form.name,
              mac: form.mac,
              mechanicalTypeId: form.mechanicalType,
              processTypeId: form.processType,
              creationTime: form.creationTime === '' ? null : moment(form.creationTime).format('YYYY-MM-DD'),
              expireDate: form.offlineTime === '' ? null : moment(form.offlineTime).format('YYYY-MM-DD'),
              nature: form.nature,
              isProductionLine: form.isProductionLine,
              isEnable: form.isEnable,
              remark: form.remark,
              sortId: form.name,
              description: form.description,
              internalIP: form.ipList[0].ip,
              externalIP: form.ipList[1].ip,
              controllerIP: form.ipList[2].ip,
              plcIP: form.ipList[3].ip,
              robotIP: form.ipList[4].ip,
              camera3DIP: form.ipList[5].ip,
              camera2DIP: form.ipList[6].ip,
              motorIP: form.ipList[7].ip,
              projectRecordId: form.project,
              qrCodeId: nullableNumber(form.qrCode),
              qrCodeUrlId: form.qrCodeUrlId,
              imgs: form.picList.map((item) => item.url),
              specificationModelId: form.specificationModelId, //规格型号
              versionId: form.versionId, //版本号
              shapeSize: form.shapeSize, //外形尺寸
              ratedVoltage: Number(form.ratedVoltage), //额定电压
              ratedPower: Number(form.ratedPower), //额定功率
              ratedAirPressure: Number(form.ratedAirPressure), //额定气压
              weight: Number(form.weight), //设备重量
              factoryDate: form.factoryDate === '' ? null : moment(form.factoryDate).format('YYYY-MM-DD'), //出厂日期
              lastMaintenanceDate: form.lastMaintenanceDate === '' ? null : moment(form.lastMaintenanceDate).format('YYYY-MM-DD'),  //上一次保养日期
              processToolingVersionId: nullableNumber(form.processToolingId),
              clampToolingVersionId: nullableNumber(form.clampToolingId),
              glueSupplySystemVersionId: nullableNumber(form.glueSupplySystemId),
              cleaningMechanismVersionId: nullableNumber(form.cleaningMechanismId),
              machineBodyVersionId: nullableNumber(form.machineBodyId),
              motionMechanismVersionId: nullableNumber(form.motionMechanismId),
            }).then(async (res) => {
              if (res.code === 0) {
                ElMessage({
                  showClose: true,
                  message: res.message,
                  type: 'warning',
                })
                return
              }
              await updateFactoryInspectionRecordInspectors()
              ElMessage({
                showClose: true,
                message: '修改成功',
                type: 'success',
              });
              formEl.resetFields();
              router.push('/equipmentList');
            }).catch((error) => {
              ElMessage({
                showClose: true,
                message: error.message || '检查人更新失败',
                type: 'warning',
              })
            })
          })
            .catch(() => {
              ElMessage({
                type: 'info',
                message: '已取消',
              })
            })
        }
      }
    } else {
      // console.log('error submit!')
      return false
    }
  })
}

const formCancel = (formEl) => {
  offlineTimeDisabled.value = true;
  if (!formEl) return
  formEl.resetFields()
  //清空图片
  // filePicList.value = []
}

const HandleChangeNature = (val) => {
  if (val === '租赁') {
    offlineTimeDisabled.value = false;
  } else {
    offlineTimeDisabled.value = true;
  }
}

onActivated(() => {
  menuIndex.value = '/equipmentAdd';
})

onDeactivated(() => {
  menuIndex.value = undefined;
})

const goPath = (path) => {
  router.push(path);
}
</script>

<style scoped>
.page-header {
  background-color: #F9F9F9;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.box-card {
  .text {
    margin-bottom: 5px;
  }
}

.factory-inspection-panel {
  width: min(100%, 960px);
}

.device-type-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 12px;
}

.device-type-radio-group ::v-deep .el-radio.is-bordered {
  margin-right: 0;
}

.inspection-owner-tag {
  min-width: 72px;
  justify-content: center;
}

.factory-inspection-panel ::v-deep .el-input {
  width: 180px;
}

::v-deep .el-button--text {
  margin-right: 15px;
}

::v-deep .el-select {
  width: 300px;
}

::v-deep .el-input,
.el-date-editor.el-input {
  width: 300px;
}

::v-deep .dialog-footer button:first-child {
  margin-right: 10px;
}

::v-deep .el-dialog__body img {
  width: 100% !important;
}

.equipmentAdd-top-block {
  padding: 8px 16px;
  background-color: #1b222b;
  border-radius: 4px;
  border-left: 5px solid var(--el-color-primary);
  margin: 20px 0;
  font-size: 14px;
  line-height: 24px;
  color: var(--text-color);
}

.isProductionLine-switch {
  width: 300px;
}

.form {
  width: 1000px;
}
</style>
